import { atom } from 'jotai'

export const createWalletDialogAtom = atom<{ isVisible: boolean }>({ isVisible: false })
